import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import {
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  signOut,
} from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import React from "react";
import App from "./App";

type CognitoUser = {
  attributes: {
    sub: string;
    email: string;
  };
  username: string;
};

function adminLoggedIn(user: CognitoUser | null): boolean {
  // admin users have their own cognito pool now, so successfully logging in means it is an admin user
  return !!user;
}

function AuthenticatedApp() {
  const [user, updateUser] = React.useState<CognitoUser | null>(null);

  const fetchUser = React.useCallback(async () => {
    try {
      const currentUser = await getCurrentUser();
      const session = await fetchAuthSession();
      const attributes = await fetchUserAttributes();

      updateUser({
        attributes: {
          sub: session.userSub ?? "",
          email: attributes.email || currentUser.signInDetails?.loginId || "",
        },
        username: currentUser.username,
      });
    } catch {
      console.log("No signed in user.");
      updateUser(null);
    }
  }, [updateUser]);

  React.useEffect(() => {
    fetchUser();

    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signedIn":
          fetchUser();
          return;
        case "signedOut":
          updateUser(null);
      }
    });
  }, [fetchUser]);

  React.useEffect(() => {
    if (!user) {
      return;
    }

    if (!adminLoggedIn(user)) {
      signOut();
    }
  }, [user]);

  if (adminLoggedIn(user)) {
    console.log(user);
    return <App />;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Authenticator loginMechanisms={["email"]} hideSignUp />
    </div>
  );
}

export default AuthenticatedApp;

